import { addMethod, date, mixed, number, ref, string } from "yup";

addMethod(date, "beforeOrEqualTo", function (ref, message) {
  return this.test("beforeOrEqualTo", message, function (value) {
    const { path, createError } = this;
    return (
      !value ||
      !ref ||
      new Date(value) <= new Date(ref) ||
      createError({
        path,
        message: message || `Date must be before or equal to ${ref}`,
      })
    );
  });
});

export const validator = {
  email: string()
    .email("Invalid email Address")
    .required("Email Address  is required"),
  firstName: string().required("First Name is required"),
  selectProgramType: string().required("Program Type is required"),
  lastName: string().required("Last Name is required"),
  phone: string().required("phone is required"),
  password: string()
    .required("Password is required")
    .max(20, "Password must have a maximum length of 20 characters")
    .matches(
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}/,
      "Password must have Upper case, Lower case and number "
    ),
  confirmPassword: string()
    .required("confirm password is required")
    .oneOf([ref("password")], "Passwords must match")
    .required("confirm password is required"),

  selectProgram: string().required("Program is required"),
  selectModeOfStudy: string().required("Mode of Study is required"),
  selectApplication: string().required("Application Batch is required"),

  institutionName: string().required("Institution name is required"),
  discipline: string().required("Discipline is required"),
  position: string().required("position is required"),
  company: string().required("Company name is required"),
  cgpa: number().required("CGPA is required"),
  startDate: date()
    .required("Start date is required")
    .max(new Date(), "Start date cannot be in the future")
    .test(
      "startDateBeforeEndDate",
      "Start date cannot be after end date",
      function (value) {
        const { endDate } = this.parent;
        return !endDate || new Date(value) <= new Date(endDate);
      }
    ),
  endDate: date()
    .required("End date is required")
    .max(new Date(), "End date cannot be in the future")
    .test(
      "endDateAfterStartDate",
      "End date cannot be before start date",
      function (value) {
        const { startDate } = this.parent;
        return !startDate || new Date(value) >= new Date(startDate);
      }
    ),
  dob: date().required("Date of birth is required"),
  upload: mixed()
    .notRequired()
    .test("is-pdf", "File must be a PDF", (value: any) => {
      if (value && value instanceof File && value.name) {
        const supportedFormats = ["pdf"];
        const fileExtension =
          value.name && value?.name?.split(".")?.pop()?.toLowerCase();
        return supportedFormats.includes(fileExtension ?? "");
      }
      return true;
    }),

  middleName: string(),
  gender: string().required("Gender is required"),
  maritalStatus: string().required("Marital status is required"),
  religion: string().required("Religion is required"),
  phoneNumber: string()
    .required("Phone number is required")
    .test("is valid phone number", "Invalid phone number", (value) => {
      const phoneRegex = /^\+?[0-9]\d{1,14}$/;
      return phoneRegex.test(value || "");
    }),
  stateOfOrigin: string().required("State of origin required"),
  lga: string().required("LGA is required"),
  address: string().required("Address is required"),
  country: string().required("Country is required"),
  city: string().required("City is required"),
  zipCode: string(),
  disability: string().required("Disability is required"),
  title: string().required("Title is required"),
};
